import { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTrips, reset } from '../../features/trips/tripSlice';
import Select from 'react-select';

export default function TripSelect({
    isDisabled,
    unassignedOptionLabel,
    preselectedTripId,
    setSelectedTripId,
    isInModal = false,
}) {
    const dispatch = useDispatch();
    const { trips } = useSelector((state) => state.trips);

    useEffect(() => {
        dispatch(getTrips());
    }, []);

    const options = useMemo(() => [{ label: unassignedOptionLabel, value: undefined }, ...trips], [trips, unassignedOptionLabel]);

    const findPreselectedTrip = () => trips.find(trip => trip.value === preselectedTripId);
    const [selectedTrip, setSelectedTrip] = useState(findPreselectedTrip() || { label: unassignedOptionLabel, value: undefined });

    useEffect(() => {
        setSelectedTripId(preselectedTripId);
        setSelectedTrip(findPreselectedTrip() || { label: unassignedOptionLabel, value: undefined });
    }, [preselectedTripId, trips]);

    const onChangeSelectTrip = (selectedOption) => {
        setSelectedTripId(selectedOption.value);
        setSelectedTrip(selectedOption);
    };

    return (
        <Select
            options={options}
            onChange={onChangeSelectTrip}
            value={selectedTrip}
            isDisabled={isDisabled}
            menuPortalTarget={
                // Dropdown menu is not properly visible in modal without this
                isInModal ? 
                document.getElementsByClassName('journey-form')[1] 
                : 
                document.body
            }
            menuPosition='fixed'
            menuPlacement={'bottom'}
        />
    );
}
